var Configuration = EY.Consultation.Lookups.Configuration;
var User = EY.Consultation.CurrentUser;


var isMultiTabEnabled = Configuration.MultiTabCheckForCurrentUser;


module.exports.isOpeningInMultiTab = function (options) {
    var lockedBy = options.lockedBy;
    var isOpenedByCurrentUser = options.isOpenedByCurrentUser;
    return !!(isMultiTabEnabled && lockedBy && lockedBy === User.upn && !isOpenedByCurrentUser);
};

module.exports.isOpenedInMultiTab = function (options) {
    return !!(isMultiTabEnabled && options.isOpenedByCurrentUser);
};

module.exports.isOpenedInOriginalTab = function (options){
    return !!(isMultiTabEnabled && !options.isOpenedByCurrentUser);
}



// WEBPACK FOOTER //
// ./js/Modules/Record/Service/MultiTab.js